/** A type tile starts a fresh browse listing; API toggle URLs retain other filters. */
export function getTypeFilterStripUrl(typeName?: string): string {
  if (!typeName?.trim()) return '/jewellery.html';
  const normalizedTypeName = typeName.trim().toLowerCase().replace(/\+/g, ' ').replace(/\s+/g, ' ');
  const tag = normalizedTypeName === 'nose accessory' ? 'nose pins' : normalizedTypeName;
  return `/jewellery/${encodeURIComponent(tag).replace(/%20/g, '+')}.html`;
}
